export const HOURS_IN_DAY = 24;
